import { cn } from '@/lib/cn';

export interface TabItem {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: TabItem[];
  activeId: string;
  onChange: (id: string) => void;
}

/** Wrapping chip tabs (used for saved views + settings sections). */
export function Tabs({ tabs, activeId, onChange }: TabsProps) {
  return (
    <div className="flex flex-wrap gap-1.5 pb-1" role="tablist">
      {tabs.map((tab) => {
        const isActive = tab.id === activeId;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={cn(
              'whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors',
              isActive ? 'bg-brand text-white' : 'bg-surface text-ink-muted hover:bg-surface-muted',
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
